import axios from 'axios'
import store from '../store/index.js'

export default function () {
  var ax = axios.create({
    headers: { 'Authorization': 'bearer ' + localStorage.getItem('token') }
  })

  ax.interceptors.response.use( function(res) {

    var refreshToken = res.headers['x-authorization'];
    if( refreshToken !== undefined ) {
        localStorage.setItem('token', refreshToken);
    }
    return res;
 
  },

  function(err){

    if (err.message === 'Network Error') {
      console.error('Server appears to be offline. Redirecting.')
      // store.dispatch('logout')
      window.location.href = '/offline'
      return Promise.resolve()
    }

    if (err.response.status === 401) {
      console.log('Redirecting on the cause of a 401 from API')
      store.dispatch('logout')
      window.location.href = '/'
      return Promise.resolve()
    }

    throw err
    
  });

  return ax
}



// WEBPACK FOOTER //
// ./WebApp/api/elg.gateway.js